/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `Low` - LOW
* `Medium` - MEDIUM
* `High` - HIGH
 */
export type PriorityEnum = typeof PriorityEnum[keyof typeof PriorityEnum];


export const PriorityEnum = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
} as const;
